module.exports = __webpack_public_path__ + "img/pattern3.b370860.svg";